import type { ICountryConfig } from "../../../controls/PhoneControl/types";
import { SupportedCountry } from "../../../controls/PhoneControl/types";
import usFlag from "@/assets/flags/us.png";

export const SUPPORTED_COUNTRIES: ICountryConfig[] = [
  {
    code: SupportedCountry.UnitedStates,
    name: "United States",
    flag: usFlag,
    callingCode: "+1",
  },
];
